import * as Locator from '@arcgis/core/rest/locator';
import PropTypes from 'prop-types';

/**
 * Reverse geocode coordinates to addresses on the Esri map using the specified geocode service.
 * The service returns an address if an address is found, or an error if it cannot find a result.
 * https://developers.arcgis.com/javascript/latest/reverse-geocode/
 * @param {String} serviceUrl - A GIS or Esri geocode service url
 * @param {Number} latitude - The location's latitude
 * @param {Number} longitude - The location's longitude
 * @param {Object} requestOptions - Additional options to be used for the reverse geocode request
 * @param {String} token - The GIS authentication token or apiKey
 */
const reverseGeocode = async ({
  serviceUrl,
  latitude,
  longitude,
  requestOptions,
  token,
}) => {
  try {
    const url = token ? (serviceUrl += `?token=${token}`) : serviceUrl;

    const params = {
      location: { latitude, longitude },
    };

    const response = await Locator.locationToAddress(
      url,
      params,
      requestOptions,
    );

    return response;
  } catch (error) {
    throw new Error();
  }
};

reverseGeocode.PropTypes = {
  serviceUrl: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  requestOptions: PropTypes.object,
  token: PropTypes.string,
};
export default reverseGeocode;
